export default __webpack_public_path__ + "b11f840e26e185c71c777fbcb359bec0.png";